import React from 'react';
import Text from 'v3/components/Text';
import { formatCurrency } from 'utils/formatter';
import { HeaderTotalSummaryContainer } from './styles';

export default function HeaderTotalSummary({ label, totalInReal, totalInDollar }) {
  return (
    <HeaderTotalSummaryContainer>
      <Text type="medium" as="p" weight={500}>
        {label}
      </Text>
      <Text type="medium" as="p" weight={500}>
        {formatCurrency(totalInReal, 'BRL', 'R$')}
      </Text>
      <Text type="medium" as="p" weight={500}>
        {formatCurrency(totalInDollar, 'USD', '$', 4)}
      </Text>
    </HeaderTotalSummaryContainer>
  );
}
